(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("testItemDetailsReport", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/testItemDetailsReportView.html",
            controller: ["reportResource", "$stateParams", "messageService", TestItemDetailsReportCtrl],
            controllerAs: "vm"
        };
        function TestItemDetailsReportCtrl(reportResource, $stateParams, messageService) {
            var vm = this;
            vm.loading = true;
            reportResource.getExamDetails({ actionValue: $stateParams.number }, function (result) {
                vm.data = result;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.getAnswers = function (question) {
                reportResource.getAnswers({ actionValue: $stateParams.number, param1: question.number }, function (result) {
                    question.answers = result.answers;
                }, function (error) {
                    messageService.error(error);
                });
            };
        }
    });
}());
